import removeDuplicateQueryParams from '../../middleware/remove-duplicate-query-params'

export default removeDuplicateQueryParams
